var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_3794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9531 15.5085V13.7109C48.9531 6.15459 42.7983 0 35.2422 0H16.7578C9.20166 0 3.04688 6.15459 3.04688 13.7109V15.5085C1.27959 16.1484 0 17.8241 0 19.8047V29.1484C0 31.6771 2.0413 33.7188 4.57031 33.7188H10.6641C11.5173 33.7188 12.1875 33.0483 12.1875 32.1953V16.7578C12.1875 15.9046 11.5173 15.2344 10.6641 15.2344H6.09375V13.7109C6.09375 7.83047 10.8773 3.04688 16.7578 3.04688H35.2422C41.1227 3.04688 45.9062 7.83047 45.9062 13.7109V15.2344H41.3359C40.4827 15.2344 39.8125 15.9046 39.8125 16.7578V32.1953C39.8125 33.0483 40.4827 33.7188 41.3359 33.7188H45.9062L47.4297 36.7656L48.9531 33.4444C50.7204 32.8351 52 31.1288 52 29.1484V19.8047C52 17.8241 50.7204 16.1484 48.9531 15.5085Z",
    fill: "url(#paint0_radial_62_3794)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8594 35.2422V13.7109C42.8594 11.1908 40.8092 9.14062 38.2891 9.14062H27.5234V7.61719C27.5234 6.77513 26.8421 6.09375 26 6.09375C25.1579 6.09375 24.4766 6.77513 24.4766 7.61719V9.14062H13.7109C11.1908 9.14062 9.14062 11.1908 9.14062 13.7109V35.2422C9.14062 37.7624 11.1908 39.8125 13.7109 39.8125H38.2891C40.8092 39.8125 42.8594 37.7624 42.8594 35.2422ZM18.3828 19.8047C18.3828 18.9626 19.0642 18.2812 19.9062 18.2812C20.7483 18.2812 21.4297 18.9626 21.4297 19.8047V22.8516C21.4297 23.6936 20.7483 24.4766 19.9062 24.4766C19.0642 24.4766 18.3828 23.6936 18.3828 22.8516V19.8047ZM29.0469 33.7188H22.9531C20.433 33.7188 18.3828 31.6686 18.3828 29.1484C18.3828 28.3064 19.0642 27.625 19.9062 27.625C20.7483 27.625 21.4297 28.3064 21.4297 29.1484C21.4297 29.9875 22.114 30.6719 22.9531 30.6719H29.0469C29.886 30.6719 30.5703 29.9875 30.5703 29.1484C30.5703 28.3064 31.2517 27.625 32.0938 27.625C32.9358 27.625 33.6172 28.3064 33.6172 29.1484C33.6172 31.6686 31.567 33.7188 29.0469 33.7188ZM33.6172 22.8516C33.6172 23.6936 32.9358 24.4766 32.0938 24.4766C31.2517 24.4766 30.5703 23.6936 30.5703 22.8516V19.8047C30.5703 18.9626 31.2517 18.2812 32.0938 18.2812C32.9358 18.2812 33.6172 18.9626 33.6172 19.8047V22.8516ZM47.4297 33.7188H45.9062V41.3359C45.9062 45.5406 42.4938 48.9531 38.2891 48.9531H30.296C30.4484 48.4655 30.5703 47.9781 30.5703 47.4297C30.5703 44.9008 28.529 42.8594 26 42.8594C23.471 42.8594 21.4297 44.9008 21.4297 47.4297C21.4297 49.9584 23.471 52 26 52H38.2891C44.1695 52 48.9531 47.2164 48.9531 41.3359V33.4444C48.4657 33.6272 47.9781 33.7188 47.4297 33.7188Z",
    fill: "url(#gradient_fill)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_fill",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "11.45%",
    stopColor: "#FFBE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8D0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_62_3794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.135955 2.76319) scale(52.486 50.9179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036185"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_3794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.a328ed0c741636ca0a7df57a73803ca4.svg";
export { ForwardRef as ReactComponent };